import { createApp } from "vue";
import { createWebHistory, createRouter } from "vue-router";

// styles

import "@fortawesome/fontawesome-free/css/all.min.css";
import "@/assets/styles/tailwind.css";

// mouting point for the whole app
import App from "@/App.vue";

// layouts
import Admin from "@/layouts/Admin.vue";
import Pesident from "@/layouts/Pesident.vue";
import DahlaCalendar from "@/layouts/DahlaCalendar.vue";
import DahlaE_Log from "@/layouts/DahlaE-Log.vue";
import DahlaAlumni from "@/layouts/DahlaAlumni.vue";
import DahlaCoAct from "@/layouts/DahlaCoAct.vue";
import DahlaSmartGrade from "@/layouts/DahlaSmartGrade.vue";
// import BinlaBook from "@/layouts/BinlaBook.vue";
// import BinlaChannel from "@/layouts/BinlaChannel.vue";
import BinlaEducation from "@/layouts/BinlaEducation.vue";


// views for Admin layout
import Dashboard from "@/views/admin/Dashboard.vue";
import General from "@/views/admin/Dashboard_General.vue";
import Subject from "@/views/admin/Subject.vue";
import Lecturer from "@/views/admin/Lecturer.vue";
import Resource from "@/views/admin/Resource.vue";
import Calendar from "@/views/admin/Dashboard_DahlaCalendar.vue";
import E_Log from "@/views/admin/Dashboard_DahlaE-Log.vue";
import E_Log_sub from "@/views/admin/Dashboard_DahlaE-Log_subject.vue";
import CoAct from "@/views/admin/Dashboard_DahlaCoAct.vue";
import Alumni from "@/views/admin/Dashboard_DahlaAlumni.vue";
import SmartGrade from "@/views/admin/Dashboard_DahlaSmartGrade.vue";
import SmartGrade_Delay from "@/views/admin/Dashboard_DahlaSmartGrade_delay.vue";
// import Book from "@/views/admin/Dashboard_BinlaBook.vue";
// import Channel from "@/views/admin/Dashboard_BinlaChannel.vue";
import Education from "@/views/admin/Dashboard_BinlaEducation.vue";

// routes
const routes = [
  {
    path: "/",
    component: Pesident,
    children: [
      {
        path: "/",
        component: Dashboard,
      },
    ],
  },
  {
    path: "/general",
    redirect: "/general",
    component: Admin,
    children: [
      {
        path: "/general",
        component: General,
      },
      {
        path: "/subject",
        component: Subject,
      },
      {
        path: "/lecturer",
        component: Lecturer,
      },
      {
        path: "/resource",
        component: Resource,
      },
    ],
  },
  {
    path: "/binla_education",
    component: BinlaEducation,
    children: [
      {
        path: "/binla_education",
        component: Education,
      },
    ],
  },
  // {
  //   path: "/binla_book",
  //   component: BinlaBook,
  //   children: [
  //     {
  //       path: "/binla_book",
  //       component: Book,
  //     },
  //   ],
  // },
  // {
  //   path: "/binla_channel",
  //   component: BinlaChannel,
  //   children: [
  //     {
  //       path: "/binla_channel",
  //       component: Channel,
  //     },
  //   ],
  // },
  {
    path: "/dahla_calendar",
    component: DahlaCalendar,
    children: [
      {
        path: "/dahla_calendar",
        component: Calendar,
      },
    ],
  },
  {
    path: "/dahla_elog",
    component: DahlaE_Log,
    redirect: "/dahla_elog",
    children: [
      {
        path: "/dahla_elog",
        component: E_Log,
      },
      {
        path: "/dahla_elog_subject",
        component: E_Log_sub,
      },
    ],
  },
  {
    path: "/dahla_co_act",
    component: DahlaCoAct,
    children: [
      {
        path: "/dahla_co_act",
        component: CoAct,
      },
    ],
  },
  {
    path: "/dahla_alumni",
    component: DahlaAlumni,
    children: [
      {
        path: "/dahla_alumni",
        component: Alumni,
      },
    ],
  },
  {
    path: "/dahla_smartgrade",
    component: DahlaSmartGrade,
    children: [
      {
        path: "/dahla_smartgrade",
        component: SmartGrade,
      },
      {
        path: "/dahla_smartgrade_dalay",
        component: SmartGrade_Delay,
      },
    ],
  },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory("/ems/president"),
  routes
});

createApp(App).use(router).mount("#app");
